/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PersonInfo model module.
 * @module model/PersonInfo
 * @version 1.0.0
 */
class PersonInfo {
    /**
     * Constructs a new <code>PersonInfo</code>.
     * @alias module:model/PersonInfo
     * @param dni {String} 
     * @param name {String} 
     * @param phone {String} 
     */
    constructor(dni, name, phone) { 
        
        PersonInfo.initialize(this, dni, name, phone);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, dni, name, phone) { 
        obj['dni'] = dni;
        obj['name'] = name;
        obj['phone'] = phone;
    }

    /**
     * Constructs a <code>PersonInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PersonInfo} obj Optional instance to populate.
     * @return {module:model/PersonInfo} The populated <code>PersonInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PersonInfo();

            if (data.hasOwnProperty('dni')) {
                obj['dni'] = ApiClient.convertToType(data['dni'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('position')) {
                obj['position'] = ApiClient.convertToType(data['position'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
            if (data.hasOwnProperty('fax')) {
                obj['fax'] = ApiClient.convertToType(data['fax'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} dni
 */
PersonInfo.prototype['dni'] = undefined;

/**
 * @member {String} name
 */
PersonInfo.prototype['name'] = undefined;

/**
 * @member {String} position
 */
PersonInfo.prototype['position'] = undefined;

/**
 * @member {String} email
 */
PersonInfo.prototype['email'] = undefined;

/**
 * @member {String} phone
 */
PersonInfo.prototype['phone'] = undefined;

/**
 * @member {String} fax
 */
PersonInfo.prototype['fax'] = undefined;






export default PersonInfo;

